import { ChangeEvent, FC, useCallback } from 'react';
import { useField } from 'react-final-form';

import {
  MaskField,
  MaskFieldProps,
} from '@beeline/design-system-react/extracted-styles';

export interface FormMaskFieldProps extends Omit<MaskFieldProps, 'value'> {
  name: string;
  validate?: (value: string | undefined) => string;
}

export const FormMaskField: FC<FormMaskFieldProps> = ({
  name,
  type,
  required,
  helperText,
  validate: validateFromProps,
  ...rest
}) => {
  const validate = useCallback(
    (value: string | undefined) => {
      if (required) {
        const trimmedValue = value?.trim();
        if (!trimmedValue) return 'Заполните поле';
      }

      if (validateFromProps) return validateFromProps(value);
    },
    [required, validateFromProps],
  );
  const { input, meta } = useField(name, { type, validate });
  const error = meta.touched ? meta.error : undefined;

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      input.onChange(event);
    },
    [input],
  );

  return (
    <MaskField
      {...rest}
      {...input}
      onInput={handleChange}
      error={!!error}
      helperText={error ?? helperText}
      type={type}
      required={required}
      onChange={handleChange}
    />
  );
};
